import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { ComparisonCompareTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonCompare.trackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsComparisonCompareImpression
    extends GoogleAnalyticsMinimumDataset {
    info: {
        products: Array<GoogleAnalyticsProduct>;
    };
}

export const getGoogleAnalyticsComparisonCompareImpression = (
    data: TypedAnalyticsEvent<ComparisonCompareTrackingInfo>
): GoogleAnalyticsComparisonCompareImpression => {
    const googleAnalyticsProducts = data.payload.eventData.products.map(
        getGoogleAnalyticsProduct
    );

    return {
        event: GoogleAnalyticsEvents.ComparisonCompare,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            products: googleAnalyticsProducts
        }
    };
};
